<template>
  <div>
    <v-row dense>
      <v-col>
        <v-text-field
            filled
            v-model="data.title"
            :error-messages="errors.title"
            label="Título"
            autocomplete="title"
            name="title"
            hide-details="auto"
            placeholder=" "
            prepend-inner-icon="mdi-format-text"
            type="text"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col>
        <v-textarea
            filled
            v-model="data.about"
            :error-messages="errors.about"
            label="Descrição"
            autocomplete="about"
            name="about"
            hide-details="auto"
            placeholder=" "
            prepend-inner-icon="mdi-format-text"
            type="text"
        ></v-textarea>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col class="col-12 col-sm-4 col-md-2">
        <v-text-field
            filled
            v-model="data.price"
            :error-messages="errors.price"
            label="Preço"
            autocomplete="price"
            name="price"
            hide-details="auto"
            placeholder=" "
            prepend-inner-icon="mdi-format-text"
            type="text"
            v-money
        ></v-text-field>
      </v-col>
      <v-col class="col-12 col-sm-4 col-md-2">
        <v-text-field
            filled
            v-model="data.power_start"
            :error-messages="errors.power_start"
            label="Força inicial"
            autocomplete="power_start"
            name="power_start"
            hide-details="auto"
            placeholder=" "
            prepend-inner-icon="mdi-format-text"
            type="text"
        ></v-text-field>
      </v-col>
      <v-col>
        <v-text-field
            filled
            v-model="data.power_end"
            :error-messages="errors.power_end"
            label="Força máxima"
            autocomplete="power_end"
            name="power_end"
            hide-details="auto"
            placeholder=" "
            prepend-inner-icon="mdi-format-text"
            type="text"
        ></v-text-field>
      </v-col>
    </v-row>
    <div
        class="mt-5 bgalpha pa-2 text-right"
    >
      <v-dialog
          v-model="deleteDialog"
          width="500"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
              color="error"
              :loading="deleteState"
              class="mr-2"
              v-on="on"
          >
            Excluir
          </v-btn>
        </template>
        <v-card>
          <v-card-title>
            Excluir Plano
          </v-card-title>
          <v-card-text>
            Deseja realmente excluir este plano?
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                color="error"
                text
                @click="deleteDialog = false"
            >
              Não
            </v-btn>
            <v-btn
                color="primary"
                text
                @click="planDelete()"
            >
              Sim
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-btn
          color="success"
          @click="planEdit()"
          :loading="editState"
      >
        Salvar
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    endpoint_load: String
  },
  mounted() {
    this.planLoad();
  },
  data() {
    return {
      errors: [],
      // xhr
      editState: false,
      deleteState: false,
      //
      deleteDialog: false,
      data: {
        id: null,
        title: null,
        about: null,
        price: null,
        power_start: null,
        power_end: null
      }
    }
  },
  methods: {
    planLoad() {
      if (this.endpoint_load) {
        this.$api
            .get(this.endpoint_load)
            .then(response => {
              this.data = response.data
            });
      }
    },
    planEdit() {
      this.editState = true;

      const payload = {
        id: this.data.id,
        title: this.data.title,
        about: this.data.about,
        price: this.data.price.toString().replace(/[^0-9]/g,''),
        power_start: this.data.power_start,
        power_end: this.data.power_end,
      }

      this.$api
          .post('/admin/plan/plan.edit', payload)
          .then(response => {
            if (! payload.id) {
              this.$router.push({
                name: 'adminPlanEdit',
                params: {
                  plan_id: response.data.id
                }
              })

              return;
            }

            this.errors = [];
            this.id = response.data.id;
            this.$root.$emit('GlobalSnackbar', { type: 'success', message: 'Plano salvo' });
          })
          .catch((error) => {
            this.errors = error.response.data.errors;
          })
          .finally(() => {
            this.editState = false;
          });
    },
    planDelete () {
      this.$api
          .post('/admin/plan/plan.remove', {
            plan_id: this.data.id
          })
          .then(response => {
            this.$root.$emit('GlobalSnackbar', { type: 'success', message: 'Plano excluído' });
            this.$router.push({
              name: 'adminPlanList'
            })
          })
          .catch((error) => {
            this.errors = error.response.data.errors;
          })
          .finally(() => {
            this.editState = false;
          });
    }
  },
}
</script>

<style>
</style>
